<template>
  <div class="mb-10">
    <SGPAlertaComponent v-if="tarefaEstaFinalizada" type="danger" class="mb-4">
      <h5>Tarefa Finalizada</h5>
      Esta tarefa foi finalizada e não pode sofrer nenhuma tratativa.
    </SGPAlertaComponent>

    <SGPAlertaComponent v-if="tarefaTipoInterrupcao" type="danger" class="mb-4">
      <h5>Tarefa de Interrupção</h5>
      Tarefas de interrupção não podem sofrer tratativas.
    </SGPAlertaComponent>

    <SGPAlertaComponent v-if="tarefaEstaInterrompida && !tarefaEstaFinalizada && !tarefaTipoInterrupcao" type="danger" class="mb-4">
      <h5>Tarefa Interrompida</h5>
      Esta tarefa está interrompida. Nenhuma tratativa pode ser executada até que a interrupção seja resolvida.
    </SGPAlertaComponent>

    <SGPAlertaComponent
      icon=""
      class="mb-4"
      v-if="podeDesfazerBloco"
    >
      <h5>Atenção !</h5>
      Caso você queira desmanchar o bloco após o tratamento, desmarque esse check!
      <SGPFormCheckboxComponent
        v-model="manter_bloco_sgp"
        label="Manter Bloco após tratativa"
        left
        hide-details
        :multiple="false"
        true-value="1"
        false-value="0"
        color="primary"
        class="manter-bloco no-padding no-margin"
        :disabled="disabledManterBloco"
      ></SGPFormCheckboxComponent>
    </SGPAlertaComponent>

    <SGPConfirmacaoComponent 
      :mostrarModal="confirmacaoBloco" 
      :titulo="'Paralelismo'"
      :mensagem="'Tratativa em bloco. Tem certeza que deseja iniciar o paralelismo para todos os circuitos?'"
      :txtConfirmar="'Sim, iniciar paralelismo'"
      @sgpConfirmarEmit="confirmarSelecao()"
      @sgpCancelarEmit="hideConfirmacaoMensagem()"
    />

    <SGPModalComponent
      v-if="podeDesfazerBloco && modalDesfazerBloco"
      :mostrarHeader="true"
      :mostrarFooter="true"
      mostrarBody
      tamanho="sm"
      :titulo="'Paralelismo'"
      @sgpModalFechar="hideConfirmacaoMensagemParalelismo"
      :toolbar="true"
    >
      <h5 class=""> O bloco será desfeito após a tratativa devido ao paralelismo </h5>
      <div class="container-botoes text-right">
        <SGPFormBotaoComponent @click="hideConfirmacaoMensagemParalelismo()">
          Ok
        </SGPFormBotaoComponent>
      </div>
    </SGPModalComponent>

    <SGPRowComponent v-if="!tarefaEstaFinalizada && !tarefaTipoInterrupcao">
      <SGPColComponent md="4">
        <SGPFormSelectComponent 
          :name="'ctrl_tratativa_id'"
          :listaDeOptions="tratativasDisponiveis"
          v-model="ctrl_tratativa_id"
          :optionLabel="'tratativa'"
          :placeholder="'Tratativa'"
          :error="validationErrors.first('ctrl_tratativa_id')"
          data-vv-as="Tratativa"
          v-validate="'required'"
          @change="habilitarCmbTarefa($event)"
        />
        <!-- <span v-if="!this.disabledTarefa && tratativaSelecionada.tratativa !== 'Atualizar'">
          <SGPFormToggleComponent 
            name="exibir_paralelismo" 
            titulo="Enviar para mais de uma tarefa"
            v-model="exibirParalelismo"  
            @input="switchExibirParalelismo" 
          />
        </span> -->
      </SGPColComponent>    

      <!-- AVISO DE TRATATIVA INDISPONÍVEL -->
      <SGPColComponent cols="12" v-if="tratativaIndisponivel" class="mt-3">
        <SGPAlertaComponent type="warning">
          A tratativa <strong>{{ tratativaSelecionada.tratativa }}</strong> está indisponível para esta tarefa.
        </SGPAlertaComponent>
      </SGPColComponent>    



      <SGPColComponent cols="4" v-if="!this.disabledTarefa && exibirParalelismo && tratativaSelecionada.tratativa !== 'Atualizar' && tratativaSelecionada.tratativa !== 'Negar Interrupção'">
        <SGPFormSelectComponent 
          selecaoMultipla
          :name="'ctrl_tarefa_id_mult'"
          :listaDeOptions="tarefasDestinoParalelismo"
          v-model="ctrlTarefasIds"
          :optionLabel="'descricao'"
          :placeholder="'Tarefa Destino'"
          :error="validationErrors.first('ctrl_tarefa_id_mult')"
          data-vv-as="Tarefa Destino"
          :disabled="disabledTarefa"
          :msgSemDados="'Tarefa sem paralelismo cadastrado'"
        />
      </SGPColComponent>

      <SGPColComponent md="4" v-if="tarefasDestino.length > 0 && tratativaSelecionada.tratativa !== 'Atualizar' && tratativaSelecionada.tratativa !== 'Negar Interrupção'">
        <SGPFormSelectComponent
          :name="'ctrl_tarefa_id'"
          :listaDeOptions="tarefasDestino"
          v-model="ctrl_tarefa_id"
          :optionLabel="'descricao'"
          :placeholder="'Tarefa Destino'"
          :error="validationErrors.first('ctrl_tarefa_id')"
          data-vv-as="Tarefa Destino"
          :disabled="disabledTarefa"
          @change="onTarefaDestinoChange"
        />
      </SGPColComponent>
    </SGPRowComponent>

    <!-- PAINEL DE ATUALIZAÇÃO / CANCELAMENTO -->
    <SGPRowComponent v-if="exibirFormDescricao" class="mt-3">
      <SGPColComponent cols="12">
        <div class="atualizar-card">
          <div class="atualizar-card__header">
            <v-icon small class="mr-2" color="primary">{{ ehCancelamento ? 'mdi-cancel' : 'mdi-pencil-outline' }}</v-icon>
            <span>{{ ehCancelamento ? 'Detalhes do cancelamento' : 'Detalhes da atualização' }}</span>
          </div>

          <div class="atualizar-card__body">
            <!-- TEXTAREA -->
            <div class="atualizar-card__section">
              <label class="atualizar-label">Descrição <span class="required-mark">*</span></label>
              <textarea
                v-model="descricaoAtualizacao"
                class="atualizar-textarea"
                :placeholder="ehCancelamento ? 'Descreva o motivo do cancelamento...' : 'Descreva o que foi feito ou observado...'"
                rows="4"
              />
              <div class="atualizar-char-count">{{ descricaoAtualizacao.length }} caracteres</div>
            </div>

            <!-- DIVIDER -->
            <div class="atualizar-divider">
              <span>Anexos <span class="grey--text text--darken-1">(opcional)</span></span>
            </div>

            <!-- DROP ZONE -->
            <div class="atualizar-card__section">
              <div
                class="upload-zone"
                :class="{ 'upload-zone--active': dragOver }"
                @dragover.prevent="dragOver = true"
                @dragleave.prevent="dragOver = false"
                @drop.prevent="onDrop"
                @click="$refs.fileInput.click()"
              >
                <input
                  ref="fileInput"
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.xls,.xlsx,.txt,.zip"
                  style="display:none"
                  @change="onFileChange"
                />
                <v-icon size="32" :color="dragOver ? 'primary' : 'grey lighten-1'">mdi-cloud-upload-outline</v-icon>
                <p class="upload-hint mb-0">Clique para selecionar ou arraste arquivos aqui</p>
                <p class="upload-hint--sub mb-0">JPG, PNG, GIF, WEBP, PDF, DOC, XLS, TXT, ZIP &bull; máx. 5MB por arquivo</p>
              </div>

              <div class="mt-3" v-if="anexos.length > 0">
                <div
                  v-for="(arquivo, idx) in anexos"
                  :key="idx"
                  class="anexo-preview-item"
                >
                  <v-icon small class="mr-2" :color="corChipArquivo(arquivo.name)">{{ iconeArquivo(arquivo.name) }}</v-icon>
                  <span class="anexo-preview-nome">{{ arquivo.name }}</span>
                  <span class="ml-2 grey--text text--darken-1 text-caption">{{ formatarTamanhoArquivo(arquivo.size) }}</span>
                  <v-spacer />
                  <v-btn icon x-small @click="removerAnexo(idx)" class="ml-2">
                    <v-icon small color="grey">mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SGPColComponent>
    </SGPRowComponent>

    <SGPRowComponent v-if="formularioTarefaDestino && !tarefaTipoInterrupcao">
      <SGPColComponent cols="12" class="mt-4">
        <!-- <h6 class="mb-3">Dados da Tarefa</h6> -->
        <RenderizaFormularioComponent
          :arrayFormId="[{ ctrl_formulario_dinamico_id: formularioTarefaDestino }]"
          :exportarDados="true"
          @dadosFormularioDinamicoEmit="atualizarDadosFormulario"
        />
      </SGPColComponent>
    </SGPRowComponent>

    <SGPRowComponent>
      <SGPColComponent cols="12" class="mt-4">
        <SGPFormBotaoComponent 
          type="submit" 
          @click="confirmarTratativa()"
          color="primary"
          :disabled="!podeConfirmar || loadingFichaTecnica"
          :loading="loadingFichaTecnica"
        >
          Confirmar Tratativa
        </SGPFormBotaoComponent>
      </SGPColComponent>
    </SGPRowComponent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import criarToast from '@/common/boot/ToastsHandler'
import EventBus from '@/common/helpers/EventBus'
// import RenderizaFormularioComponent from '@/modules/forms/formularios/components/RenderizaFormularioComponent'
import { getProvedorAtivoId } from '../../helpers/provedorHelper'
import RenderizacaoFormularioDinamicoComponent from '@/modules/workflow/forms/ctrl-formularios-dinamicos/components/RenderizacaoFormularioDinamicoComponent/RenderizacaoFormularioDinamicoComponent.vue'

export default {
  name: "TratativaComponent",

  components: {
    RenderizaFormularioComponent: RenderizacaoFormularioDinamicoComponent
  },

  props: {
    tratativas: {
      type: Array,
      required: true
    },
    pco_tarefa: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      ctrl_tratativa_id: '',
      ctrl_tarefa_id: '',
      exibirParalelismo: '',
      ctrl_tratativa_opcao_id: '',
      descricaoAtualizacao: '',
      tarefasDestino: [],
      manter_bloco_sgp: "1",
      disabledTarefa: true,
      disabledManterBloco: false,
      modalDesfazerBloco: false,
      tratativaSelecionada: {},
      ctrlTarefasIds: [],
      tarefasDestinoParalelismo: [],
      confirmacaoBloco: false,
      validarBlocoParalelismo: (this.pco_tarefa && this.pco_tarefa.ctrl_bloco_id != null) ? true : false,
      carregandoTarefas: false,
      formularioTarefaDestino: null,
      formularioTarefaDestinoId: null,
      dadosFormularioPreenchido: {},
      anexos: [],
      dragOver: false
    }
  },

  computed: {
    ...mapGetters('ctrlTarefasMobilidades', [
      'listaDeTarefasDestino'
    ]),

    ...mapGetters('fichaTecnicaWorkflow', [
      'loadingFichaTecnica',
      'historicoTicket'
    ]),

    ...mapGetters('login', ['usuarioLogado']),

    usuarioEhAdmin() {
      const normalizarRole = (nome) => String(nome ?? '').trim().toLowerCase();
      const usuario = this.usuarioLogado;
      if (!usuario?.id) return false;

      const roles = Array.isArray(usuario.roles) ? usuario.roles : [];
      if (roles.some(role => normalizarRole(role?.name) === 'administrador')) {
        return true;
      }

      const roleAtivo = usuario.role_ativo;
      const nomeRoleAtivo = typeof roleAtivo === 'string' ? roleAtivo : (roleAtivo?.name ?? roleAtivo?.role_name);
      return normalizarRole(nomeRoleAtivo) === 'administrador';
    },

    ehCancelamento() {
      return this.tratativaSelecionada?.tratativa === 'Cancelar';
    },

    exibirFormDescricao() {
      return this.tratativaSelecionada?.tratativa === 'Atualizar' || this.ehCancelamento;
    },

    podeDesfazerBloco() {
      return (
        this.pco_tarefa &&
        this.pco_tarefa.ctrl_bloco &&
        this.pco_tarefa.ctrl_bloco.ctrl_tipo_bloco_id != 1 &&
        this.tratativaSelecionada &&
        this.tratativaSelecionada.ctrl_tipo_tarefa_id &&
        !this.tarefaEstaFinalizada &&
        !this.tarefaTipoInterrupcao
      );
    },

    tratativasDisponiveis() {
      if (!this.tratativas || !Array.isArray(this.tratativas)) {
        return [];
      }

      return this.tratativas.filter(item => {
          if (!item) return false;
          
          const tratativasExcluidas = ['adotado', 'apropriar', 'liberar'];
          const tratativaNormalizada = item.tratativa.toLowerCase();
          
          if (tratativasExcluidas.includes(tratativaNormalizada)) {
            return false;
          }

          if (tratativaNormalizada === 'cancelar' && !this.usuarioEhAdmin) {
            return false;
          }
          
          // Tratativas que não precisam de tarefa destino - sempre disponíveis
          const tratativasSemTarefaDestino = ['Atualizar', 'Negar Interrupção', 'Cancelar'];
          if (tratativasSemTarefaDestino.includes(item.tratativa)) {
            return true;
          }

          if (!item.ctrl_tipo_tarefa_id) {
            return true;
          }

          if (!this.tarefasMobilidades || !Array.isArray(this.tarefasMobilidades)) {
            return false;
          }

          const tarefas = this.tarefasMobilidades.filter(tarefa => {
            return tarefa &&
                tarefa.ctrl_tipo_tarefa_id == item.ctrl_tipo_tarefa_id &&
                tarefa.ctrl_conclusao_id == item.ctrl_conclusao_id;
          });

          return tarefas.length > 0;
        });
    },

    tarefasMobilidades() {
      if (!this.pco_tarefa || !this.pco_tarefa.mobilidades) {
        return [];
      }

      return this.pco_tarefa.mobilidades.map(item => {
        if (!item || !item.ctrl_tarefa_destino) return null;
        return {
          id: item.ctrl_tarefa_destino.id,
          descricao: item.ctrl_tarefa_destino.tarefa || item.ctrl_tarefa_destino.descricao || 'Tarefa sem nome',
          ctrl_tipo_tarefa_id: item.ctrl_tarefa_destino.ctrl_tipo_tarefa_id,
          ctrl_conclusao_id: item.ctrl_tarefa_destino.ctrl_conclusao_id,
          ctrl_formulario_id: item.ctrl_tarefa_destino.ctrl_formulario_id,
          ctrl_tarefa_mobilidade_id: item.id,
          paralelismo: item.paralelismo
        };
      }).filter(item => item !== null);
    },

    tarafaTipoInterrupcao() {
      return this.pco_tarefa?.ctrl_tarefa?.tipo_tarefa?.tipo === 'Interrupção';
    },

    tarefaEstaInterrompida() {
      return this.pco_tarefa?.pco_tarefa_interrupcao_id !== null;
    },

    tarefaEstaFinalizada() {
      return this.pco_tarefa?.finalized_at !== null;
    },

    podeConfirmar() {
      // Bloqueia se a tarefa está finalizada
      if (this.tarefaEstaFinalizada) {
        return false;
      }

      // Bloqueia se a tarefa é do tipo interrupção
      if (this.tarefaTipoInterrupcao) {
        return false;
      }

      // Bloqueia se a tarefa está interrompida
      if (this.tarefaEstaInterrompida) {
        return false;
      }

      if (this.carregandoTarefas) {
        return false;
      }

      if (!this.ctrl_tratativa_id) {
        return false;
      }

      // Para Atualizar, Negar Interrupção e Cancelar, não precisa de tarefa destino
      if (this.tratativaSelecionada.tratativa === 'Atualizar' || 
          this.tratativaSelecionada.tratativa === 'Negar Interrupção' ||
          this.tratativaSelecionada.tratativa === 'Cancelar') {
        return true;
      }

      if (!this.disabledTarefa) {
        if (this.exibirParalelismo) {
          return this.ctrlTarefasIds.length > 0;
        } else {
          return !!this.ctrl_tarefa_id;
        }
      }

      return true;
    },

    tratativaIndisponivel() {
      return (
        this.ctrl_tratativa_id &&
        this.tratativaSelecionada &&
        this.tratativaSelecionada.tratativa !== 'Atualizar' &&
        this.tratativaSelecionada.tratativa !== 'Negar Interrupção' &&
        this.tratativaSelecionada.tratativa !== 'Cancelar' &&
        !this.carregandoTarefas &&
        this.tarefasDestino.length === 0
      );
    }
  },
  methods: {
    ...mapActions('fichaTecnicaWorkflow', [
      'concluirTratamentoTarefa',
      'buscarDadosFichaTecnicaTarefa',
      'avancarTarefa',
      'devolverTarefaWorkflow',
      'atualizarTarefa',
      'interromperTarefa',
      'solicitarInterrupcao',
      'negarInterrupcao',
      'cancelarTarefa',
      'buscarHistoricoTicket'
    ]),

    async avancarParaProximaTarefa(ticketId) {
      if (!ticketId) return;

      try {
        await this.buscarHistoricoTicket(ticketId);
      } catch (error) {
        return;
      }

      const tarefaAtualId = Number(this.$route.params.pco_tarefa_id);
      const proximaTarefa = (this.historicoTicket?.tarefas || []).find(
        tarefa => tarefa.finalized_at === null && tarefa.id !== tarefaAtualId
      );

      if (proximaTarefa) {
        this.$router.push({
          name: 'ficha-tecnica-tarefa',
          params: { pco_tarefa_id: String(proximaTarefa.id) }
        });
      }
    },

    ...mapActions('ctrlTarefasMobilidades', [
      'listarTarefasDestinoDisponiveis'
    ]),

    async switchExibirParalelismo() {
      this.ctrl_tarefa_id = '';
      this.ctrlTarefasIds = [];

      if (this.exibirParalelismo) {
        this.manter_bloco_sgp = "0";
        this.tarefasDestinoParalelismo = this.tarefasDestino.filter(item => item.paralelismo == 1);
      }
    },

    onTarefaDestinoChange() {
      const tarefaSelecionada = this.tarefasDestino.find(t => t.id === this.ctrl_tarefa_id);
      
      if (tarefaSelecionada && tarefaSelecionada.formulario) {
        this.formularioTarefaDestino = tarefaSelecionada.formulario.id;
        this.formularioTarefaDestinoId = tarefaSelecionada.formulario.id;
        this.dadosFormularioPreenchido = {};
      } else {
        this.formularioTarefaDestino = null;
        this.formularioTarefaDestinoId = null;
        this.dadosFormularioPreenchido = {};
      }
    },

    atualizarDadosFormulario(dadosFormulario) {      
      if (dadosFormulario && dadosFormulario.values) {
        this.dadosFormularioPreenchido = JSON.parse(JSON.stringify(dadosFormulario.values));
      } else {
        this.dadosFormularioPreenchido = JSON.parse(JSON.stringify(dadosFormulario));
      }
    },

    habilitarCmbTarefa(event) {
      if(typeof event == 'undefined' || this.tarefaEstaFinalizada) {
        return false;
      }
      
      // Tratativas que não usam seleção de tarefa
      if (this.tratativaSelecionada.tratativa === 'Atualizar' || 
          this.tratativaSelecionada.tratativa === 'Negar Interrupção' ||
          this.tratativaSelecionada.tratativa === 'Cancelar') {
        this.disabledTarefa = true;
        this.descricaoAtualizacao = '';
        this.formularioTarefaDestino = null;
        this.formularioTarefaDestinoId = null;
        this.dadosFormularioPreenchido = {};
        return;
      }

      // O watcher de ctrl_tratativa_id já cuida de listar as tarefas
      // Apenas resetar campos se necessário
      this.ctrl_tarefa_id = '';
      this.ctrlTarefasIds = [];
      this.formularioTarefaDestino = null;
      this.formularioTarefaDestinoId = null;
      this.dadosFormularioPreenchido = {};
    },
    filtraTarefasDestino() {
      this.tarefasDestino = this.listaDeTarefasDestino.map(item => ({
        id: item.id,
        descricao: item.tarefa,
        paralelismo: item.paralelismo || 0,
        formulario: item.form || null,
        map: item.map
      }));
    },

    async confirmarTratativa() {
      if (this.tarefaEstaFinalizada) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Tarefa finalizada não pode sofrer tratativas.'
        });
        return;
      }

      if (this.exibirParalelismo && this.validarBlocoParalelismo && 
          this.verificarBlocoComParalelismo(this.exibirParalelismo ? this.ctrlTarefasIds : [this.ctrl_tarefa_id])) {
        this.confirmacaoBloco = true;
        return;
      }

      await this.executarTratativa();
    },

    async executarTratativa() {
      if (this.tarefaEstaInterrompida) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Esta tarefa está interrompida. Nenhuma tratativa pode ser realizada.'
        });
        return;
      }

      const tratativa = this.getTratativaSelecionada();
      
      if (tratativa && tratativa.tratativa === 'Atualizar') {
        await this.executarAtualizar();
        return;
      }

      if (tratativa && (tratativa.tratativa === 'Avançar' || tratativa.tratativa === 'Devolver')) {
        await this.executarAvancadorDevolver();
        return;
      }

      if (tratativa && tratativa.tratativa === 'Interrupção') {
        await this.executarInterromper();
        return;
      }

      if (tratativa && tratativa.tratativa === 'Solicitar Interrupção') {
        await this.executarSolicitarInterrupcao();
        return;
      }

      if (tratativa && tratativa.tratativa === 'Negar Interrupção') {
        await this.executarNegarInterrupcao();
        return;
      }

      if (tratativa && tratativa.tratativa === 'Cancelar') {
        await this.executarCancelar();
        return;
      }

      const payload = {
        tarefa_id: this.$route.params.pco_tarefa_id,
        pco_tarefa_id: this.$route.params.pco_tarefa_id,
        pco_tratamento_id: this.pco_tarefa.pco_tratamento_id,
        ctrl_tratativa_id: this.ctrl_tratativa_id,
        pco_circuito_id: this.pcoCircuitoId,
        ctrl_tratativa_opcao_id: this.ctrl_tratativa_opcao_id,
        manter_bloco_sgp: parseInt(this.manter_bloco_sgp),
        exibir_paralelismo: this.exibirParalelismo,
        dados_formulario_tarefa: this.dadosFormularioPreenchido,
        ctrl_formulario_id: this.formularioTarefaDestinoId
      };

      if (this.ctrl_tarefa_id != '' && this.ctrl_tarefa_id != null || this.ctrlTarefasIds.length > 0) {
        payload.ctrl_tarefa_id = (this.exibirParalelismo == true) ? this.ctrlTarefasIds : [this.ctrl_tarefa_id];
      }

      await this.concluirTratamentoTarefa(payload);
      await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);

      const ticketId = getProvedorAtivoId(this.pco_tarefa?.workflow);
      if (ticketId) {
        EventBus.$emit('tratativaAtualizada', ticketId);
      }

      this.$emit('tratativaExecutada');
      await this.avancarParaProximaTarefa(ticketId);
    },

    async executarAtualizar() {
      if (this.tarefaEstaInterrompida) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Esta tarefa está interrompida. Nenhuma tratativa pode ser realizada.'
        });
        return;
      }

      if (!this.descricaoAtualizacao.trim()) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Descreva a atualização'
        });
        return;
      }

      const payload = {
        pco_tarefa_id: this.$route.params.pco_tarefa_id,
        descricao: this.descricaoAtualizacao,
        anexos: this.anexos
      };

      try {
        await this.atualizarTarefa(payload);
        await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
        
        const ticketId = getProvedorAtivoId(this.pco_tarefa?.workflow);
        if (ticketId) {
          EventBus.$emit('tratativaAtualizada', ticketId);
        }
        
        this.descricaoAtualizacao = '';
        this.anexos = [];
        this.$emit('tratativaExecutada');
      } catch (error) {
        console.error('Erro ao atualizar tarefa:', error);
      }
    },

    async executarAvancadorDevolver() {
      if (this.tarefaEstaInterrompida) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Esta tarefa está interrompida. Nenhuma tratativa pode ser realizada.'
        });
        return;
      }

      const tratativa = this.getTratativaSelecionada();

      if (!this.ctrl_tarefa_id) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Selecione uma tarefa destino'
        });
        return;
      }

      const payload = {
        pco_tarefa_id: this.$route.params.pco_tarefa_id,
        ctrl_tarefa_id: this.ctrl_tarefa_id,
        dados_formulario_tarefa: this.dadosFormularioPreenchido,
        ctrl_formulario_id: this.formularioTarefaDestinoId
      };

      try {
        if (tratativa.tratativa === 'Avançar') {
          await this.avancarTarefa(payload);
        } else if (tratativa.tratativa === 'Devolver') {
          await this.devolverTarefaWorkflow(payload);
        }

        await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);

        const ticketId = getProvedorAtivoId(this.pco_tarefa?.workflow);
        if (ticketId) {
          EventBus.$emit('tratativaAtualizada', ticketId);
        }

        this.$emit('tratativaExecutada');
        await this.avancarParaProximaTarefa(ticketId);
      } catch (error) {
        console.error('Erro ao executar ação:', error);
      }
    },

    async executarInterromper() {
      if (this.tarefaEstaInterrompida) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Esta tarefa está interrompida. Nenhuma tratativa pode ser realizada.'
        });
        return;
      }

      if (!this.ctrl_tarefa_id) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Selecione uma tarefa destino'
        });
        return;
      }

      const payload = {
        pco_tarefa_id: this.$route.params.pco_tarefa_id,
        ctrl_tarefa_id: this.ctrl_tarefa_id,
        dados_formulario_tarefa: this.dadosFormularioPreenchido,
        ctrl_formulario_id: this.formularioTarefaDestinoId
      };

      try {
        await this.interromperTarefa(payload);
        await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);

        const ticketId = getProvedorAtivoId(this.pco_tarefa?.workflow);
        if (ticketId) {
          EventBus.$emit('tratativaAtualizada', ticketId);
        }

        this.$emit('tratativaExecutada');
        await this.avancarParaProximaTarefa(ticketId);
      } catch (error) {
        console.error('Erro ao interromper tarefa:', error);
      }
    },

    async executarSolicitarInterrupcao() {
      if (this.tarefaEstaInterrompida) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Esta tarefa está interrompida. Nenhuma tratativa pode ser realizada.'
        });
        return;
      }

      if (!this.ctrl_tarefa_id) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Selecione uma tarefa destino'
        });
        return;
      }

      const payload = {
        pco_tarefa_id: this.$route.params.pco_tarefa_id,
        ctrl_tarefa_id: this.ctrl_tarefa_id,
        dados_formulario_tarefa: this.dadosFormularioPreenchido,
        ctrl_formulario_id: this.formularioTarefaDestinoId
      };

      try {
        await this.solicitarInterrupcao(payload);
        await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);

        const ticketId = getProvedorAtivoId(this.pco_tarefa?.workflow);
        if (ticketId) {
          EventBus.$emit('tratativaAtualizada', ticketId);
        }

        this.$emit('tratativaExecutada');
        await this.avancarParaProximaTarefa(ticketId);
      } catch (error) {
        console.error('Erro ao solicitar interrupção:', error);
      }
    },

    async executarCancelar() {
      if (!this.usuarioEhAdmin) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Apenas administradores podem cancelar tarefas.'
        });
        return;
      }

      if (!this.descricaoAtualizacao.trim()) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Descreva o motivo do cancelamento'
        });
        return;
      }

      const payload = {
        pco_tarefa_id: this.$route.params.pco_tarefa_id,
        descricao: this.descricaoAtualizacao,
        anexos: this.anexos
      };

      try {
        await this.cancelarTarefa(payload);
        await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
        
        const ticketId = getProvedorAtivoId(this.pco_tarefa?.workflow);
        if (ticketId) {
          EventBus.$emit('tratativaAtualizada', ticketId);
        }
        
        this.descricaoAtualizacao = '';
        this.anexos = [];
        this.$emit('tratativaExecutada');
      } catch (error) {
        console.error('Erro ao cancelar tarefa:', error);
      }
    },

    async executarNegarInterrupcao() {
      if (this.tarefaEstaInterrompida) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Esta tarefa está interrompida. Nenhuma tratativa pode ser realizada.'
        });
        return;
      }

      const payload = {
        pco_tarefa_id: this.$route.params.pco_tarefa_id,
        dados_formulario_tarefa: this.dadosFormularioPreenchido,
        ctrl_formulario_id: this.formularioTarefaDestinoId
      };

      try {
        await this.negarInterrupcao(payload);
        await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
        
        const ticketId = getProvedorAtivoId(this.pco_tarefa?.workflow);
        if (ticketId) {
          EventBus.$emit('tratativaAtualizada', ticketId);
        }
        
        this.$emit('tratativaExecutada');
      } catch (error) {
        console.error('Erro ao negar interrupção:', error);
      }
    },

    onFileChange(event) {
      this.adicionarArquivos(Array.from(event.target.files));
      event.target.value = '';
    },

    onDrop(event) {
      this.dragOver = false;
      this.adicionarArquivos(Array.from(event.dataTransfer.files));
    },

    adicionarArquivos(files) {
      const maxSize = 5 * 1024 * 1024;
      files.forEach(file => {
        if (file.size > maxSize) {
          criarToast({ tipo: 'warning', mensagem: `"${file.name}" excede o limite de 5MB.` });
          return;
        }
        this.anexos.push(file);
      });
    },

    removerAnexo(idx) {
      this.anexos.splice(idx, 1);
    },

    formatarTamanhoArquivo(bytes) {
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / 1048576).toFixed(1)} MB`;
    },

    iconeArquivo(nome) {
      const ext = nome.split('.').pop().toLowerCase();
      const mapa = {
        pdf: 'mdi-file-pdf-box',
        doc: 'mdi-file-word-box', docx: 'mdi-file-word-box',
        xls: 'mdi-file-excel-box', xlsx: 'mdi-file-excel-box',
        jpg: 'mdi-file-image', jpeg: 'mdi-file-image',
        png: 'mdi-file-image', gif: 'mdi-file-image', webp: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        zip: 'mdi-folder-zip-outline',
      };
      return mapa[ext] || 'mdi-file-outline';
    },

    corChipArquivo(nome) {
      const ext = nome.split('.').pop().toLowerCase();
      const cores = {
        pdf: 'red', doc: 'blue lighten-1', docx: 'blue lighten-1',
        xls: 'green', xlsx: 'green',
        jpg: 'purple', jpeg: 'purple', png: 'purple', gif: 'purple', webp: 'purple',
        txt: 'grey', zip: 'orange',
      };
      return cores[ext] || 'grey';
    },

    getTratativaSelecionada() {
      return this.tratativas.find(tratativa => tratativa.id === this.ctrl_tratativa_id);
    },

    getTarefaSelecionada() {
      return this.tarefasDestino.find(tarefa => tarefa.id === this.ctrl_tarefa_id);
    },

    confirmarSelecao() {
      this.validarBlocoParalelismo = false;
      this.hideConfirmacaoMensagem();
      this.executarTratativa();
    },

    hideConfirmacaoMensagem() {
      this.confirmacaoBloco = false;
    },

    hideConfirmacaoMensagemParalelismo() {
      this.modalDesfazerBloco = false;
    },

    verificarBlocoComParalelismo(ctrlTarefasIdArray) {
      if (this.pco_tarefa.ctrl_bloco_id == null) {
        return false;
      }

      let blocoComParalelismo = false;

      for (const item of ctrlTarefasIdArray) {
        blocoComParalelismo = this.verificarSePossuiParalelismo(item);

        if (blocoComParalelismo) {
          break;
        }
      }
        
      return blocoComParalelismo;
    },

    verificarSePossuiParalelismo(ctrlTarefaDestinoId) {
      let tarefaMobilidade = this.pco_tarefa.mobilidades.filter(
        item => item.ctrl_tarefa_destino_id == ctrlTarefaDestinoId
      );

      if (tarefaMobilidade[0].paralelismo == 1) {
        return true;
      } else {
        return false;
      }
    }
  },

  watch: {
    ctrl_tratativa_id(val) {
      this.tratativaSelecionada = this.tratativasDisponiveis.find(tratativa => tratativa.id === val);
      this.manter_bloco_sgp = "1";
      this.formularioTarefaDestino = null;
      this.formularioTarefaDestinoId = null;
      this.dadosFormularioPreenchido = {};
      this.anexos = [];
      this.descricaoAtualizacao = '';

      const tratativasSemTarefaDestino = ['Atualizar', 'Negar Interrupção', 'Cancelar'];

      if (this.tratativaSelecionada && !tratativasSemTarefaDestino.includes(this.tratativaSelecionada.tratativa)) {
        this.carregandoTarefas = true;
        
        this.listarTarefasDestinoDisponiveis({
          ctrl_tarefa_origem_id: this.pco_tarefa.ctrl_tarefa_id,
          ctrl_tratativa_id: val
        }).then(() => {
          this.$nextTick(() => {
            this.filtraTarefasDestino();
            this.ctrl_tratativa_opcao_id = '';
            this.ctrl_tarefa_id = '';
            this.exibirParalelismo = '';
            this.ctrlTarefasIds = [];
            this.formularioTarefaDestino = null;
            this.formularioTarefaDestinoId = null;
            this.dadosFormularioPreenchido = {};

            if (this.tarefasDestino.length > 0) {
              this.disabledTarefa = false;
            } else {
              this.disabledTarefa = true;
            }

            this.carregandoTarefas = false;
          });
        }).catch(() => {
          this.carregandoTarefas = false;
        });
      } else {
        this.carregandoTarefas = false;
      }
    },

    listaDeTarefasDestino(newVal) {
      // Atualiza quando a lista muda
      if (newVal && newVal.length > 0) {
        this.filtraTarefasDestino();
        this.disabledTarefa = false;
      }
    },

    exibirParalelismo(val) {
      if (val) {
        this.manter_bloco_sgp = "0";
        this.disabledManterBloco = true;
        this.modalDesfazerBloco = true;
      } else {
        this.manter_bloco_sgp = "1";
        this.disabledManterBloco = false;
        this.modalDesfazerBloco = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #E3262E;

.manter-bloco .v-input--checkbox {
  margin-top: 0 !important;
}

// ── Atualizar card ──────────────────────────────────────────────
.atualizar-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;

  &__header {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background: #f5f5f5;
    border-bottom: 1px solid #e0e0e0;
    font-size: 13px;
    font-weight: 600;
    color: #424242;
  }

  &__body {
    padding: 16px;
  }

  &__section + &__section {
    margin-top: 4px;
  }
}

.atualizar-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #616161;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.required-mark {
  color: $primary;
}

.atualizar-textarea {
  width: 100%;
  resize: vertical;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.6;
  color: #212121;
  outline: none;
  transition: border-color 0.2s;
  font-family: inherit;
  min-height: 96px;

  &::placeholder {
    color: #9e9e9e;
  }

  &:focus {
    border-color: $primary;
  }
}

.atualizar-char-count {
  text-align: right;
  font-size: 11px;
  color: #9e9e9e;
  margin-top: 4px;
}

.atualizar-divider {
  display: flex;
  align-items: center;
  margin: 16px 0 12px;
  font-size: 12px;
  font-weight: 600;
  color: #616161;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  gap: 10px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e0e0e0;
  }
}

// ── Upload zone ─────────────────────────────────────────────────
.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 20px 16px;
  border: 2px dashed #e0e0e0;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  text-align: center;

  &:hover,
  &--active {
    border-color: $primary;
    background: #fff5f5;
  }
}

.upload-hint {
  font-size: 13px;
  font-weight: 500;
  color: #424242;
}

.upload-hint--sub {
  font-size: 12px;
  color: #9e9e9e;
}

// ── Anexo preview list ──────────────────────────────────────────
.anexo-preview-item {
  display: flex;
  align-items: center;
  padding: 7px 10px;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  background: #fafafa;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
}

.anexo-preview-nome {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>